import React, { useEffect, useRef } from 'react';

import { NamedLink } from '../../../components';
import MemberIcon from '../MemberIcon';

import css from './Kyc.module.css';

/**
 * "Verify your identity…" (member area N2; Member Home design 1d). Shown when
 * a member without KYC tries to enquire on a listing, create a listing or
 * request an introduction (decision D10). "Start KYC" opens the KYC page.
 *
 * Without KYC means nothing uploaded yet: a passport waiting for review is
 * enough to go on, as today.
 */
const KycRequiredModal = props => {
  const { isOpen, onClose, closeLabel = 'Not now' } = props;
  const dialogRef = useRef(null);

  // Focus the dialog when it opens; Escape closes it.
  useEffect(() => {
    if (!isOpen) return undefined;
    if (dialogRef.current) dialogRef.current.focus();
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={css.overlay} onClick={onClose}>
      <div
        ref={dialogRef}
        tabIndex={-1}
        className={css.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="kycRequiredTitle"
        onClick={e => e.stopPropagation()}
      >
        <span className={css.dialogIcon}>
          <MemberIcon name="kyc" size={22} />
        </span>
        <h2 id="kycRequiredTitle" className={css.dialogTitle}>
          Verify your identity to contact members and enquire on listings
        </h2>
        <p className={css.dialogText}>
          Every Parnexus member completes KYC before contacting a counterparty. It keeps every
          conversation private and trusted.
        </p>
        <div className={css.dialogButtons}>
          <NamedLink name="UploadPassportPage" className={css.primaryButton}>
            Start KYC
          </NamedLink>
          <button type="button" className={css.secondaryButton} onClick={onClose}>
            {closeLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default KycRequiredModal;
